<template>
  <b-container fluid>
    <b-card>
      <b-row class="my-1">
        <b-col sm="6">
          <b-input-group class="mt-3">
            <b-input-group-prepend is-text>
              Search Pod:&nbsp;&nbsp;
              <b-icon icon="search"></b-icon>
            </b-input-group-prepend>
            <b-form-input v-model="filter" sm="3"></b-form-input>
            <b-button v-if="filter" v-on:click="clearAll" variant="light"><b-icon aria-hidden="true" icon="trash"/></b-button>
          </b-input-group>
        </b-col>
      </b-row>
     </b-card>
    <b-table
      responsive
      striped
      hover
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items="results"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      @filtered="onFiltered"
      class="table-romeflex"
    >
      <template #cell(row)="data">
        <b-button size="sm" @click="data.toggleDetails">
          {{ data.detailsShowing ? 'Hide' : 'Show' }} Details
        </b-button>
      </template>
      <template #row-details="data">
        <b-card>
          <b-row class="mb-3">
            <b-col><b>Network Unavailability Status:</b> {{data.item.networkUnavailabilityStatus}}</b-col>
            <b-col><b>Network Unavailability Start Time:</b> {{data.item.networkUnavailabilityStartTime}}</b-col>
            <b-col><b>Network Unavailability End Time:</b> {{data.item.networkUnavailabilityEndTime}}</b-col>
            <b-col><b>Rd Activation Status Update Time:</b> {{data.item.rdActivationStatusUpdateTime}}</b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col><b>Flexibility Type:</b> {{data.item.flexibilityType}}</b-col>
            <b-col><b>pnp:</b> {{data.item.pnp}}</b-col>
            <b-col><b>inp:</b> {{data.item.inp}}</b-col>
            <b-col><b>inq:</b> {{data.item.inq}}</b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col><b>cnq:</b> {{data.item.cnq}}</b-col>
            <b-col><b>cosPhi:</b> {{data.item.cosPhi}}</b-col>
            <b-col><b>upperP:</b> {{data.item.upperP}}</b-col>
            <b-col><b>downP:</b> {{data.item.downP}}</b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col><b>upperQ:</b> {{data.item.upperQ}}</b-col>
            <b-col><b>downQ:</b> {{data.item.downQ}}</b-col>
            <b-col><b>Time Power:</b> {{data.item.timePower}}</b-col>
            <b-col><b>End Time Power:</b> {{data.item.endTimePower}}</b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col><b>Max Time Power:</b> {{data.item.maxTimePower}}</b-col>
            <b-col><b>Min Time Power:</b> {{data.item.minTimePower}}</b-col>
            <b-col><b>Start Time Power:</b> {{data.item.startTimePower}}</b-col>
             <b-col><b>Recovery Time Power:</b> {{data.item.recoveryTimePower}}</b-col>
          </b-row>
          <b-card class="text-center">
            <b>Baseline:</b>
            <b-button v-b-tooltip.hover title="Workday" size="sm" class="mf-1" v-on:click="fillData(data.item.baselineId, 'workday')" v-b-modal.modalP>Workday</b-button>
            <b-button v-b-tooltip.hover title="PreHoliday" size="sm" class="mf-1" v-on:click="fillData(data.item.baselineId, 'preholiday')" v-b-modal.modalP>PreHoliday</b-button>
            <b-button v-b-tooltip.hover title="Holiday" size="sm" class="mf-1" v-on:click="fillData(data.item.baselineId, 'holiday')" v-b-modal.modalP>Holiday</b-button>
            </b-card>
        </b-card>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="results.length"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    <b-modal id="modalP" title="Chart" hide-footer size="xl" @ok="handleOk" ref="modal">
          <line-chart class="line-chart" :chartData="datacollection" :options="options"></line-chart>
    </b-modal>
  </b-container>
</template>

<style>
.btn-sm, .btn-group-sm > .btn {
    padding: 0.25rem 0.25rem;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 0.2rem;
}
.create-button {
  margin-bottom: 20px;
}
.input-group-text {
  color: #fff;
  background-color: #F7931E !important;
}
.mf-1{
  color: #fff;
  background-color: #e6047e;
}
.line-chart {
  height : 300px;
}
</style>

<script>
import PodsService from '@/services/PodsService'
import BaselineService from '@/services/BaselineService'
import LineChart from './LineChart.js'

export default {
  components: {
    LineChart
  },
  mounted () {
    this.getPods()
  },
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              type: 'time',
              time: {
                unit: 'hour'
              }
            }
          ],
          yAxes: []
        }
      },
      datacollection: {
        datasets: []
      },
      filter: null,
      sortBy: 'start',
      sortDesc: true,
      results: [],
      fields: [
        { key: 'pod', label: 'Pod Id', sortable: true },
        { key: 'baselineId', label: 'Baseline Id', sortable: true },
        { key: 'aggregatorId', label: 'Aggregator', sortable: true },
        { key: 'productCode', label: 'Product code', sortable: true },
        { key: 'pom', label: 'PoM', sortable: true },
        /* { key: 'flexibilityPerimeterArea', label: 'Flexibility Perimeter Area', sortable: true }, */
        { key: 'rdActivationStatus', label: 'Status', sortable: true },
        { key: 'row', label: '' }
      ],
      form: {},
      currentPage: 1,
      perPage: 10,
      chartOptions1: {
        colors: ['#002f6c', '#c43e00', '#003d00'],
        chart: {
          height: 350,
          type: 'line'
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          display: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: 'Power (Kw)'
          }
        }
      },
      series: null
    }
  },
  methods: {
    async getPods () {
      const response = await PodsService.getPods()
      this.results = response.data
    },
    async getBaseline (baselineId) {
      try {
        const response = await BaselineService.getBaseline(baselineId)

        // Verifica che ci siano dati nella risposta
        if (!response || !response.data || !response.data.length) {
          console.warn('No baseline data received')
          return []
        }

        const baselineData = response.data[0]

        // Verifica che powerBaselineCurves esista
        if (!baselineData || !baselineData.powerBaselineCurves) {
          console.warn('No power baseline curves found')
          return []
        }

        let result = baselineData

        return result
      } catch (error) {
        console.error('Error fetching baseline:', error)
        return []
      }
    },
    handleOk (evt) {
      // Prevent modal from closing
      evt.preventDefault()
    },
    async fillData (baselineId, line) {
      const baseline = await this.getBaseline(baselineId)
      let dataBaseline = {}
      switch (line) {
        case 'workday':
          dataBaseline = baseline.powerBaselineCurves.Workday || []
          break
        case 'preholiday':
          dataBaseline = baseline.powerBaselineCurves.PreHoliday || []
          break
        case 'holiday':
          dataBaseline = baseline.powerBaselineCurves.Holiday || []
          break
        default:
          console.warn('Invalid line type specified')
          return []
      }

      // Se non ci sono dati, ritorna senza fare ulteriori elaborazioni
      // Inizializza il datacollection con un dataset vuoto
      this.datacollection = {
        datasets: [
          {
            label: 'Active Power (kW)',
            borderColor: '#B70B6D',
            tension: 0.1,
            fill: false,
            data: []
          },
          {
            label: 'Reactive Power (kW)',
            borderColor: '#47d4f7',
            tension: 0.1,
            fill: false,
            data: []
          }
        ]
      }

      // Se non ci sono dati, ritorna senza fare ulteriori elaborazioni
      if (!dataBaseline || !dataBaseline.length) {
        console.warn('No baseline data available')
        return
      }
      // Procedi con l'elaborazione dei dati
      dataBaseline.forEach(item => {
        let index = item.index || item.timeSlotIndex

        if (Number.isInteger(index)) {
          // const timestamp = new Date()
          const timestamp = new Date(baseline.baselineStartValidity)
          timestamp.setHours(0, 0, 0)
          timestamp.setMinutes(timestamp.getMinutes() + Number(index * 15))

          this.datacollection.datasets[0].data.push({
            x: timestamp,
            y: (item.p || 0) / 1000
          })
          this.datacollection.datasets[1].data.push({
            x: timestamp,
            y: (item.q || 0) / 1000
          })
        }
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    clearAll () {
      this.filter = null
      this.totalRows = this.results.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pods.vue